import { Component, type ErrorInfo, type ReactNode } from "react";
import { RefreshCw } from "lucide-react";

type Props = {
  children: ReactNode;
};

type State = {
  failed: boolean;
};

export class AppErrorBoundary extends Component<Props, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Application render failed", error, info);
  }

  render() {
    if (this.state.failed) {
      return (
        <main className="flex min-h-svh flex-col items-center justify-center bg-white px-4 text-center">
          <a href="/" className="mb-8 flex items-center gap-2">
            <img src="/icon-transparent.svg" alt="" width={32} height={32} />
            <span className="text-xl font-semibold text-gray-950">amifine.com</span>
          </a>
          <h1 className="text-xl font-semibold text-gray-950">Something went wrong</h1>
          <p className="mt-2 max-w-xs text-sm leading-5 text-gray-500">
            Refresh the page to continue.
          </p>
          <button
            className="mt-5 inline-flex cursor-pointer items-center gap-2 rounded-xl bg-black px-5 py-3 text-sm font-semibold text-white"
            type="button"
            onClick={() => window.location.reload()}
          >
            <RefreshCw size={17} aria-hidden="true" />
            Refresh page
          </button>
        </main>
      );
    }

    return this.props.children;
  }
}
